import type { PetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type PetitionPageMediaMentionsCardExperiment =
	PetitionDetailsPageUserData['experiments']['petitionPageMediaMentionsCardExperiment'];

type Result = Readonly<{
	experiment: PetitionPageMediaMentionsCardExperiment;
	/** Whether to render the Change-owned card instead of the third-party iframely embed. */
	showCard: boolean;
}>;

/**
 * Reads the `petition_page_media_mentions_card_experiment` assignment.
 *
 * While the FCM is off the experiment resolves to its fallback (`control`), so `showCard` is false
 * and the section renders exactly as it does today.
 */
export function useMediaHitsCardExperiment(): Result {
	const {
		data: {
			experiments: { petitionPageMediaMentionsCardExperiment: experiment },
		},
	} = usePetitionDetailsPageUserData();

	return { experiment, showCard: experiment.variation === 'treatment' };
}
